import { Tag } from 'baseui/tag';
import { MEDIA_ORIGIN_OPTIONS } from '../../../constants/media';
import { useStyles } from '../../../hooks/useStyles';
import { MediaOrigin } from '../../../types/media';

type Props = {
  origin: MediaOrigin;
};

function EvidenceMediaOriginTag({ origin }: Readonly<Props>) {
  const { theme } = useStyles();

  return (
    <Tag
      kind="accent"
      hierarchy="primary"
      closeable={false}
      size="small"
      overrides={{
        Root: {
          style: {
            marginLeft: 0,
            marginRight: 0,
            marginTop: 0,
            marginBottom: 0,
            fontSize: theme.sizing.scale500,
            paddingTop: theme.sizing.scale0,
            paddingBottom: theme.sizing.scale0,
            paddingRight: theme.sizing.scale300,
            paddingLeft: theme.sizing.scale300,
            borderTopLeftRadius: theme.sizing.scale800,
            borderTopRightRadius: theme.sizing.scale800,
            borderBottomRightRadius: theme.sizing.scale800,
            borderBottomLeftRadius: theme.sizing.scale800,
          },
        },
      }}
    >
      {MEDIA_ORIGIN_OPTIONS.find((option) => option.id === origin)?.label}
    </Tag>
  );
}

export default EvidenceMediaOriginTag;
